import axios from "axios";
import {
  GET_ORDER_COUNT,
  GET_ONLINE_ORDER,
  ERROR_MASSAGE,
  SUCCESS_MESSAGE,
  SET_ONLINE_TABLE_BOOKING_COUNT,
} from "./types";
import appConfig from "../helpers/appConfig";
import { isServerLogout } from "../utils/isServerLogout";
export const getOrderCount = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `${appConfig.endpoint}/api/v1/employee/orders/ordercount`
    );
    const Count = res.data.data;
    localStorage.setItem("onlineOrderCount", JSON.stringify(Count));
    dispatch({ type: GET_ORDER_COUNT, payload: Count });
  } catch (error) {
    if (error.response) {

      if (error.response.status === 401) {
        isServerLogout(error.response)
      } else {
        dispatch({ type: ERROR_MASSAGE, payload: error.response });
      }
    }
  }
};
export const getOnlineTableBookingCount = () => async (dispatch) => {
  try {
    const res = await axios.get(`${appConfig.endpoint}/onlineordercount`);
    localStorage.setItem("onlineTableCount", res.data.data);
    dispatch({ type: SET_ONLINE_TABLE_BOOKING_COUNT, payload: res.data.data });
  } catch (error) {
    if (error.response) {

      if (error.response.status === 401) {
        isServerLogout(error.response)
      } else {
        dispatch({ type: ERROR_MASSAGE, payload: error.response });
      }
    }
  }
};

export const getOnlineOrders = (data) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${appConfig.endpoint}/api/v1/employee/orders/getOrders`,
      data
    );
    dispatch({ type: GET_ONLINE_ORDER, payload: res.data });
  } catch (error) {
    if (error.response) {

      if (error.response.status === 401) {
        isServerLogout(error.response)
      } else {
        dispatch({ type: ERROR_MASSAGE, payload: error.response });
      }
    }
  }
};
export const changeOrderStatus = (data) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${appConfig.endpoint}/api/v1/employee/orders/onlineinvoicecreation`,
      data
    );
    dispatch({
      type: SUCCESS_MESSAGE,
      payload: { ...res.data, actionType: "changeOrderStatus" },
    });

    if (
      res.data.status == 200 &&
      res.data.message == "invoice generated and order delivered"
    ) {
      dispatch(reduceDeliveryStock(data.id));
    }
  } catch (error) {
    if (error.response) {

      if (error.response.status === 401) {
        isServerLogout(error.response)
      } else {
        dispatch({ type: ERROR_MASSAGE, payload: error.response });
      }
    }
  }
};
export const reduceDeliveryStock = (id) => async (dispatch) => {
  try {
    let data = { id: id };

    const res = await axios.post(
      `${appConfig.endpoint}/api/v1/employee/board/reduceDeliveredStock`,
      data
    );
  } catch (error) {
    if (error.response) {

      if (error.response.status === 401) {
        isServerLogout(error.response)
      } else {
        dispatch({ type: ERROR_MASSAGE, payload: error.response });
      }
    }
  }
};
